import { ApplicationView } from "@mixitone/mvc";
import { useCallback, useLayoutEffect, useRef } from "react";
import { FundingOutreachFormController } from "components/Pages/Funding/FundingOutreachFormController";
import { MessageStackMessage } from "components/Pages/Funding/MessageStackMessage";

const MessageStackContent = () => {
  const controller = FundingOutreachFormController.use();
  const { communications } = controller.state;
  const scrollRef = useRef<HTMLDivElement>(null);
  const comms = Array.from(communications);
  const lastCommId = comms[comms.length - 1]?.id ?? "";
  const commCount = comms.length;

  const scrollToBottom = useCallback(() => {
    const el = scrollRef.current;
    if (!el || commCount === 0) return;
    const run = () => {
      el.scrollTop = el.scrollHeight;
    };
    run();
    requestAnimationFrame(run);
    requestAnimationFrame(() => requestAnimationFrame(run));
  }, [commCount]);

  useLayoutEffect(() => {
    scrollToBottom();
  }, [lastCommId, commCount, scrollToBottom]);

  return (
    <div ref={scrollRef} className="min-h-0 flex-1 overflow-x-hidden overflow-y-auto">
      <ul className="flex flex-col gap-2 py-1">
        {communications.map((comm) => (
          <MessageStackMessage key={comm.id} comm={comm} />
        ))}
      </ul>
    </div>
  );
};

export const MessageStack = ApplicationView(MessageStackContent);
